import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarWithNameComponent } from './avatar-with-name.component';
import { AuRoundAvatarModule } from '@shared/ui-components/au-round-avatar/au-round-avatar.module';
import { AuLogoPlaceholderModule } from '@shared/ui-components/au-logo-placeholder/au-logo-placeholder.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		AuRoundAvatarModule,
		AuLogoPlaceholderModule,
		MatTooltipModule,
		AvatarWithNameComponent,
	],
	exports: [AvatarWithNameComponent],
})
export class AuAvatarWithNameModule {}
